import consumer from "./consumer"

function defaultAvatarUrl() {
  return typeof window.defaultAvatarUrl === "string" && window.defaultAvatarUrl
    ? window.defaultAvatarUrl
    : "";
}

function setIncomingModalAvatars(avatarUrl) {
  var $incoming = $("#incomingCall");
  var fallback = $incoming.data("default-avatar") || defaultAvatarUrl();
  var src = avatarUrl || fallback;
  $("#incomingCall, #rejectedModal")
    .find("img")
    .each(function () {
      var img = this;
      img.onerror = function () {
        img.onerror = null;
        img.src = fallback;
      };
      img.src = src;
      img.setAttribute("data-original", src);
    });
}

consumer.subscriptions.create("CallChannel", {
  connected() {
    // console.log('Call channel connected');
    // Called when the subscription is ready for use on the server
    this.sendPing();
    this.pingInterval = setInterval(() => this.sendPing(), 30000);
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
    // console.log('Call channel disconnected');
    clearInterval(this.pingInterval);
  },

  sendPing() {
    this.perform("ping");
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel

    // Professional
    if (data.action == 'calling') {
      if (window.__incomingCallAccepting || window.__incomingCallAccepted) {
        return;
      }

      var caller = data.content.caller;

      playAudio("#audio-calling");

      $('#incomingCall .call-from').html('Chamada de ' + caller.display_name);
      $('#incomingCall .estimated-time').html('Tempo estimado: ' + caller.estimated_time_in_minutes + ' minutos');

      if (caller.estimated_value !== 0) {
        $('#incomingCall .estimated-value').html('Valor estimado: ' + caller.estimated_value);
      } else {
        $('#incomingCall .estimated-value').html('Valor estimado: Grátis');
      }

      setIncomingModalAvatars(caller.avatar);

      $('#incomingCall .btn-call-accept').data('user-slug', caller.slug);
      $('#rejectedModal #user_slug').val(caller.slug);

      if (!$('#rejectedModal:visible').length) {
        $('#incomingCall:not(.call-accepted)').modal('show');
      }
    }

    // User and Professional
    if (data.action == 'missed') {
      stopAudio("#audio-calling");

      $('#incomingCall').modal('hide');
      $('#callModal .reason-message').html('Profissional indisponível');
      $('#callModal .btn-cancel').removeClass('d-block').addClass('d-none');
      $('#callModal .btn-close').removeClass('d-none').addClass('d-block');
    }

    // User and Professional
    if (data.action == 'call_canceled') {
      stopAudio("#audio-calling");
      $('#incomingCall, #callModal').modal('hide');
    }

    // User and Professional
    if (data.action == 'call_accepted') {
      var conference_uuid = data.content.conference_uuid;

      stopAudio("#audio-calling");
      $('#incomingCall, #callModal').modal('hide');

      if ($('body').attr('data-calling')) {
        $('body').removeAttr('data-calling');
        window.location.href = '/conferences/' + conference_uuid;
      }
    }

    // User
    if (data.action == 'call_rejected') {
      stopAudio("#audio-calling");
      var reason = '';

      if (data && data.content && data.content.reason) {
        reason = data.content.reason;
      }

      $('#rejectedModal').modal('hide');

      if ($('#callModal:visible').length) {
        $('#callModal .reason-message').html('Profissional indisponível<br />' + reason);
        $('#callModal .btn-cancel').removeClass('d-block').addClass('d-none');
        $('#callModal .btn-close').removeClass('d-none').addClass('d-block');
      } else {
        var professional_user_slug = data.content.professional_user_slug;
        var professional_user_display_name = data.content.professional_user_display_name;

        window.openChatPopup(professional_user_slug, professional_user_display_name);
      }
    }

    // User and Professional
    if (data.action == 'call_user_payment_unauthorized' || data.action == 'call_professional_payment_unauthorized') {
      $('#incomingCall, #callModal').modal('hide');
      $('body').removeAttr('data-calling');
    }

    // User
    if (data.action == 'call_user_payment_unauthorized') {
      $('#userPaymentUnauthorized').modal('show');
    }

    // Professional
    if (data.action == 'call_professional_payment_unauthorized') {
      $('#professionalPaymentUnauthorized').modal('show');
    }

    if (data.action == 'finish_user' && window.location.href.includes('/conferences/' + data.room_id)) {
      // console.log('finish_user');
      window.location.href = '/conferences/' + data.room_id + '/ratings';
    }

    if (data.action == 'finish_professional' && window.location.href.includes('/conferences/' + data.room_id)) {
      // console.log('finish_professional');
      window.location.href = `/account?tab=conference`;
    }
  }
});
